import React from 'react';
import { Link } from '../components/ui/Link';
import { Components } from '../components/ui/Components';
import ObjectUtils from '../utils/ObjectUtils';
import { mergeClassNames } from '../utils/mergeClassNames';
import { Banner } from '../components/ui/Banner';
import { ThumbList } from '../components/ui/ThumbList';

export default class ContentBuilder
{

	private static _defaultParsers = {
		Banner: Banner,
		ThumbList: ThumbList,	
	}

	static build(items, parser = {}, styles = {})
	{
		if(!items) return;
		if(!Array.isArray(items)) items = [items];
		parser = Object.assign(this._defaultParsers, parser);
		return items.map((e, i)=>{
			let tag = e.tag;
			if(!tag) tag = 'div';
			let props = e['props'] || {};
			let content = e.content;
			if(Array.isArray(content) || typeof(content) == 'object') content = this.build(content, parser, styles);
			else content = this.linkify(content);
			let el;
			if(typeof(e) == 'string')
			{
				tag = null;
				props = {className: 'text'};
				content = this.linkify(e);
			}
			props['key'] = i;

			if(props['className'])
			{
				props['className'] = mergeClassNames(props['className'], styles);
			}

			if(parser[tag]?.prototype instanceof React.Component)
			{
				return React.createElement(parser[tag], props, content);
			}
			if(parser[tag])
			{
				return parser[tag](tag, props, content);
			}

			if(tag == 'youtube')
			{
				return (<div className='youtube'>
					<iframe src={'//youtube.com/embed/' + e.id}></iframe>
					{
						(e['description'])?
						(
							<div className='description'>{this.linkify(e['description'])}</div>
						):null
					}
				</div>)
			}else
			{
				if(Components[tag])
				{
					tag = Components[tag];
				}else if(tag == 'div')
				{
				}else if(tag == 'img')
				{
					content = null;
				}

				if(tag != null)
				{
					el = React.createElement(tag, props, content);
				}else
				{
					el = (<React.Fragment key={props['key']}>{content}</React.Fragment>);
				}
			}

			if(tag == 'img')
			{
        if(!props['className']) props['className'] = '';
        props['className'] = mergeClassNames([...props['className'].split(' '), 'img'], styles);

        return (<div key={i + '_img'} className={props['className']}>
					{el}
					{
						(e['description'])?
						(
							<div className='description'>{this.linkify(e['description'])}</div>
						):null
					}
				</div>)
			}else
			{
				return el;
			}
		});
	}

	static linkify(content:string)
	{
		if(!content) return content;
		if(typeof(content) != 'string') return content;
		let splitted = content.split(/(\[\[.*?\]\])/);
		let o;
		return splitted.map((e, i)=>{
			if(o = /^\[\[(.*?)\]\]$/.exec(e))
			{
				let link, label, action;
				link = label = o[1];
				if(o = o[1].split('|'))
				{
					if(o.length > 1)
					{
						link = o[0];
						label = o[1];
					}
				}

				return (
					<Link href={link} key={i} target='_blank'>{label}</Link>
				);
			}else{
				return e;
			}
		});
	}
}